export const kinetips = [
  {
    id: "dos-bureau",
    title: "Mal de dos au bureau : 5 gestes simples à adopter",
    excerpt:
      "Posture, pauses actives, réglage de l'écran : nos conseils pour soulager le bas du dos quand on travaille assis.",
    date: "16 sept.",
    readTime: "6 min de lecture",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/b1aab03f-89d6-45cf-a7e5-982dd1473223.jpg",
    imageAlt: "Personne effectuant un étirement du dos à son bureau",
  },
  {
    id: "premiere-seance-hydrojet",
    title: "Hydrojet : à quoi s'attendre lors d'une première séance",
    excerpt:
      "Habillé, allongé, au chaud : on vous explique le déroulé d'un soin Hydrojet et ses bienfaits sur la récupération.",
    date: "4 sept.",
    readTime: "2 min de lecture",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/df2f68b5-1ff4-42a7-917f-577a36d2f71e.jpg",
    imageAlt: "Table d'hydrojet dans une salle lumineuse du cabinet",
  },
];
